<template>
  <div class="col-md-6 col-sm-6 col-lg-4 col-12 dataTable-info">
    <div class="col-12 row">
      <div class="col-md-6 col-sm-6 col-lg-3">
        <hk-select v-model="optionSelected" :placeholder="$t('key_select_option')" :options="optionsRows"></hk-select>
      </div>
      {{ $t('key_text_rows_per_page') }}
    </div>
  </div>
</template>

<script>
import HkSelect from "@/hotaka/components/HkSelect.vue";

export default {
  name: "EntriesPerPage",
  components:{
    HkSelect
  },
  props: {
    /* options: {
      type: Array,
      default: null,
    }, */
    current: {
      type: Number,
      default: 10,
    }
  },
  emits: ['change'],
  data() {
    return {
    optionSelected: 20,
    optionsRows: [
      { value: 5, label: "5" },
      { value: 10, label: "10" },
      { value: 15, label: "15" },
      { value: 20, label: "20" },
      { value: 50, label: "50" },
      { value: 50, label: "100" },
      { value: 50, label: "200" }
    ]
    };
  },
  watch:{
    optionSelected(val) {
      if (val != this.current) {
        this.$emit('change', val);
      }
    },
    current(){
      this.optionSelected = this.current;
    }
  },
  mounted() {
    this.optionSelected = this.current;
  }
};
</script>
